<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Download's</h3>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 md4 text-xs-right>
        <v-text-field
          label="Pesquisar"
          v-model="filtro"
          color="secondary"
          append-icon="search"
        ></v-text-field>
      </v-flex>
      <v-flex xs1 text-xs-right>
        <v-tooltip color="secondary" bottom>
          <v-btn
            slot="activator"
            dark
            small
            color="secondary"
            @click="novoDoc(1)"
            depressed
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Adicionar um novo documento</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          <v-data-table
            :headers="headers"
            :items="listaDocumento"
            class="elevation-1"
            :search="filtro"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.titulo }}</td>
              <td><a @click="download(props.item.url)">Download</a></td>
              <td>
                {{
                  customFormatComputed.toLocaleDateTimeString(
                    props.item.dataIncluso
                  )
                }}
              </td>
            </template>
          </v-data-table>
        </v-card>
        <v-dialog v-model="dialog" max-width="900px" @mousedown="close()">
          <v-card
            ><v-card-title class="pt-0">
              <span class="headline pb-0">Adicionar Documento</span>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-form
                v-model="formularioCadastroValido"
                ref="formularioCadastroRef"
              >
                <v-container grid-list-md class="pa-0">
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md12>
                        <v-text-field
                          v-model="cadastroModel.titulo"
                          color="secondary"
                          prepend-icon="chrome_reader_mode"
                          label="Titulo"
                          :rules="regras.branco50"
                          riquired
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <vue-dropzone
                          ref="dropzoneRef"
                          id="dropzone"
                          :options="dropzoneOptions"
                          @vdropzone-sending="uploadArquivo"
                          @vdropzone-file-added="arquivoSelecionado = true"
                          @vdropzone-removed-file="arquivoSelecionado = false"
                          @vdropzone-success="finalizaUpload"
                          @vdropzone-error="uploadError"
                        >
                        </vue-dropzone>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      id="fechar"
                      color="primary"
                      class="grey--text text--darken-1"
                      @click="close"
                      flat
                      >Fechar</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      id="finalizar"
                      color="primary"
                      class="default-border"
                      depressed
                      :disabled="disableBtnFinalizar || !formValid"
                      @click="finalizar"
                      >Finalizar</v-btn
                    ></v-card-actions
                  >
                </v-container>
              </v-form>
            </v-card-text>
          </v-card> </v-dialog
        >Ï
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="3200"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar"
      bottom
      multi-line
    >
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import cipher from "@/helpers/cipher.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";
import usuarioHelper from "@/helpers/usuario.js";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "Download",
  components: {
    vueDropzone: vue2Dropzone,
  },
  data: () => ({
    snackbarModel: {
      mostrar: false,
      sucesso: false,
      text: "",
    },
    dialog: false,
    formularioCadastroValido: false,
    disableBtnFinalizar: false,
    filtro: "",
    pagination: { sortBy: "dataIncluso", descending: true, rowsPerPage: 20 },
    headers: [
      { text: "Titulo", value: "titulo" },
      { text: "Arquivo", value: "url" },
      { text: "Data Incluso", value: "dataIncluso" },
    ],
    listaDocumento: [],
    cadastroModel: {
      idDocumento: 0,
      usuario: {
        idUsuario: jwt.decryptToken().id,
        conta: { idConta: jwt.decryptToken().idconta },
      },
      url: null,
      titulo: "",
    },
    arquivoSelecionado: false,
    dropzoneOptions: {
      url: `${process.env.URL_API}/arquivo/v1/file/upload`,
      method: "POST",
      maxFiles: 1,
      autoProcessQueue: false,
      createImageThumbnails: false,
      addRemoveLinks: true,
      uploadMultiple: false,
      dictDefaultMessage: "Selecione ou arraste o arquivo",
      dictRemoveFile: "Remover arquivo",
      dictCancelUpload: "Cancelar envio",
      dictUploadCanceled: "Envio cancelado",
      dictCancelUploadConfirmation: "Deseja mesmo cancelar o envio?",
    },
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
      branco50: [
        (v) => !!v || "Você não pode deixar este campo em branco",
        (v) =>
          v.length < 50 ||
          "O campo deve ter 50 caracteres no maximo ou mais caracteres",
      ],
    },
  }),
  mounted: function () {
    this.buscarDocumentos();
    //this.externalSnackbarMessage();
  },
  computed: {
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
    formValid: function () {
      return this.formularioCadastroValido;
    },
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
  },
  watch: {
    dialog(val) {
      const self = this;
      if (!val) {
        self.close();
      }
    },
  },
  methods: {
    uploadArquivo: async function (file, xhr, formData) {
      const self = this;
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + JSON.parse(localStorage.getItem("token"))
      );

      formData.append("uploadfile", file);
    },
    finalizaUpload: function (file, response) {
      const self = this;

      self.snackbarModel.mostrar = true;
      self.snackbarModel.sucesso = response;
      self.snackbarModel.mensagem = response
        ? "Arquivo enviado com sucesso."
        : "Houve um problema ao enviar o arquivo.";

      self.cadastroModel.url = file.xhr.response;
      self.botaoEnviar = true;

      self.$http
        .post(
          `${process.env.URL_API}/arquivo/v1/cadastro/documento`,
          self.cadastroModel,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          const data = response.data;
          self.close();
          self.buscarDocumentos();
          self.snackbarModel.text = data.mensagem;
          self.snackbarModel.sucesso = true;
          self.snackbarModel.mostrar = true;
          self.disableBtnFinalizar = false;
        })
        .catch(function (error) {
          self.snackbarModel.text = error.response.data.message;
          self.snackbarModel.sucesso = false;
          self.snackbarModel.mostrar = true;
          self.disableBtnFinalizar = false;
        });
    },
    uploadError: function (file, response) {
      const self = this;
      self.snackbarModel.mostrar = true;
      self.snackbarModel.sucesso = false;
      self.snackbarModel.mensagem = response.message;
    },
    novoDoc(idEmpresa) {
      const self = this;
      self.dialog = true;
    },
    close() {
      const self = this;
      self.cadastroModel.url = null;
      self.cadastroModel.titulo = "";
      self.arquivoSelecionado = false;
      this.$refs.dropzoneRef.removeAllFiles(true);
      self.dialog = false;
    },
    finalizar: function () {
      const self = this;

      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          this.$refs.dropzoneRef.processQueue();
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    download(urlFull) {
      const self = this;
      const urls = urlFull.split("/");
      var nomeArquivo = urls[urls.length - 1];

      self.$http
        .get(`${process.env.URL_API}/arquivo/v1/file/` + nomeArquivo, {
          responseType: "blob",
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("token")),
          },
        })
        .then((response) => {
          let blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = nomeArquivo;
          link.click();
          return response.data;
        });
    },
    buscarDocumentos: function () {
      const self = this;

      self.$http
        .get(
          `${process.env.URL_API}/arquivo/v1/busca/` +
            self.usuarioLogado.id +
            "/" +
            self.usuarioLogado.idconta,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          self.listaDocumento = response.data;
        });
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clientes/Download.vue